import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEtsMobile = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 8,
			fill: "#F5F5F5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 8,
			fill: "url(#paint0_linear_4764_457)",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.9155 18.5969C33.5116 18.5969 33.9964 18.1139 33.9964 17.516H34C34 16.92 33.517 16.4352 32.9191 16.4352H32.6732V12.3182C32.6732 8.82784 29.8435 6 26.355 6H12.3182C8.82784 6 6 8.82964 6 12.3182V26.373C6 29.8634 8.82964 32.6912 12.3182 32.6912H15.9323V32.7828C15.9323 33.3789 16.4171 33.8637 17.0132 33.8637C17.6093 33.8637 18.0941 33.3807 18.0941 32.7828V27.172C18.0941 26.5759 17.6093 26.0911 17.0132 26.0911C16.4171 26.0911 15.9323 26.5741 15.9323 27.172V27.3731H13.3901C12.2464 27.3731 11.3181 26.4448 11.3181 25.3011V13.3919C11.3181 12.2482 12.2464 11.3199 13.3901 11.3199H25.2795C26.4232 11.3199 27.3514 12.2482 27.3514 13.3919V16.4352H27.3047C26.7087 16.4352 26.2239 16.92 26.2239 17.516C26.2239 18.1121 26.7069 18.5969 27.3047 18.5969H32.9155Z",
			fill: "#3C3C3B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.9156 22.2021C33.5117 22.2021 33.9964 21.7192 33.9964 21.1213L33.9946 21.1231C33.9946 20.527 33.5117 20.0422 32.9138 20.0422H27.303C26.7069 20.0422 26.2221 20.527 26.2221 21.1231C26.2221 21.7192 26.7051 22.2039 27.303 22.2039H27.3497V25.276C27.3497 26.4197 26.4214 27.3479 25.2777 27.3479H21.782V27.1737C21.782 26.5777 21.2972 26.0929 20.7011 26.0929C20.105 26.0929 19.6202 26.5759 19.6202 27.1737V32.7845C19.6202 33.3806 20.105 33.8654 20.7011 33.8654C21.2972 33.8654 21.782 33.3824 21.782 32.7845V32.666H26.3514C29.8417 32.666 32.6696 29.8364 32.6696 26.3478V22.2021H32.9156Z",
			fill: "#76368C"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_4764_457",
			x1: 38.5,
			y1: 38.5,
			x2: -16652e-10,
			y2: -1,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "white",
				stopOpacity: 0
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#76368C"
			})]
		}) })
	]
});
export default SvgEtsMobile;
